var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25.5,
    height: 30,
    viewBox: "0 0 25.5 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .filtercls {\n        fill: none;\n        stroke: #16151a;\n        stroke-miterlimit: 10;\n        stroke-width: 1.5px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38",
    transform: "translate(0.562 -0.063)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_22",
    className: "filtercls",
    y2: 7,
    transform: "translate(2.188 0.063)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    className: "filtercls",
    y2: 11,
    transform: "translate(2.188 19.063)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    className: "filtercls",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(0.188 10.063)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    className: "filtercls",
    y2: 15,
    transform: "translate(12.188 0.063)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    className: "filtercls",
    y2: 3,
    transform: "translate(12.188 27.063)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    className: "filtercls",
    cx: 3,
    cy: 3,
    r: 3,
    transform: "translate(9.188 18.063)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    className: "filtercls",
    y2: 3,
    transform: "translate(22.188 0.063)"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    className: "filtercls",
    y2: 15,
    transform: "translate(22.188 15.063)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    className: "filtercls",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(19.188 7.063)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.1f2caff3d43fbb17e650005115d3cc6e.svg";
export { ForwardRef as ReactComponent };